import { TestType } from '@risksmart-app/domain/src/types/consts/test-type';
import { z } from 'zod';

import type { UserOption } from '../../../../schemas/global';
import {
  CustomAttributeDataSchema,
  FileOrRelationSchema,
  StringDateSchema,
  UserOptionSchema,
} from '../../../../schemas/global';
const effectiveness = z
  .number({
    invalid_type_error: 'Required',
  })
  .min(0)
  .max(4);

export const TestResultFormSchema = z
  .object({
    Title: z.string().nullish(),
    TestType: z
      .nativeEnum(TestType, {
        required_error: 'Required',
        invalid_type_error: 'Required',
      })
      .nullish(),
    Description: z.string().nullish(),
    DesignEffectiveness: effectiveness.nullish(),
    PerformanceEffectiveness: effectiveness.nullish(),
    OverallEffectiveness: effectiveness.nullish(),
    Id: z.string().uuid().optional(),
    OversightAssessmentId: z.string().uuid().nullish(),
    ParentControlIds: z
      .array(
        z.object({
          value: z
            .string({ required_error: 'Required' })
            .uuid({ message: 'Required' }),
        })
      )
      .min(1),
    Submitter: UserOptionSchema,
    TestDate: StringDateSchema,
    files: z.array(FileOrRelationSchema),
  })
  .and(CustomAttributeDataSchema);

export type TestResultFormFieldsData = z.infer<typeof TestResultFormSchema>;

/**
 * Creation is the only mode without an Id in the form values: every edit
 * flow (standard modal, oversight, internal audit, assessment finding)
 * spreads the fetched test result — including its Id — into `values`,
 * while create flows either omit Id or pass no `values` at all.
 */
export const isCreateTestResult = (
  values: Pick<TestResultFormFieldsData, 'Id'> | undefined
): boolean => !values?.Id;

export const defaultValues: TestResultFormFieldsData = {
  OverallEffectiveness: undefined as unknown as number,
  ParentControlIds: [],
  TestDate: '',
  TestType: undefined as unknown as TestType,
  Title: null,
  Description: '',
  DesignEffectiveness: null,
  PerformanceEffectiveness: null,
  files: [],
  Submitter: null as unknown as UserOption,
  CustomAttributeData: null,
  OversightAssessmentId: null,
};
